import { ChakraProvider } from '@chakra-ui/react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import chakraTheme from '@/theme/chakra';
import '@fontsource/nunito/400.css';

createRoot(document.getElementById('root') as HTMLElement).render(
  <ChakraProvider theme={chakraTheme}>
    <App />
  </ChakraProvider>
);
